module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_vm._m(0), _c('form', [_c('input', {
    attrs: {
      "name": "SPREADSHEET_ID",
      "type": "hidden",
      "value": "1RTlomP3hXQZhHw3arZfng3dJeGJAnz3EcreOeYM1npA"
    }
  }), _c('input', {
    attrs: {
      "name": "SHEET_NAME",
      "type": "hidden",
      "value": "フォームデータ"
    }
  }), _vm._m(1), _vm._m(2), _vm._m(3), _c('div', {
    staticClass: "form text-center"
  }, [_c('button', {
    staticClass: "form_submit",
    attrs: {
      "type": "button",
      "id": "submit"
    },
    on: {
      "click": function($event) {
        _vm.sendMessage()
      }
    }
  }, [_vm._v("Submit")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "headline page_headline"
  }, [_vm._v("Contact "), _c('div', {
    staticClass: "sub"
  }, [_vm._v("お問い合わせ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_vm._v("メールアドレス")]), _c('input', {
    staticClass: "wide",
    attrs: {
      "type": "email",
      "name": "your-email",
      "placeholder": "your@email.com"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_vm._v("お名前")]), _c('input', {
    staticClass: "wide",
    attrs: {
      "type": "text",
      "name": "your-name",
      "placeholder": "Your Name"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('label', {
    staticClass: "form__label"
  }, [_vm._v("メッセージ"), _c('span', {
    staticClass: "label-required"
  }, [_vm._v("必須")])]), _c('textarea', {
    attrs: {
      "name": "your-message",
      "placeholder": "Message",
      "rows": "8",
      "required": "required",
      "id": "message"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfe2109e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 43
// module chunks = 0